import { type FC } from "react";
import { type OptionProps } from "@root/shared/components/SelectBox";
import { type WorkContentAlbum } from "@clientFrontend/features/publication/type/type";
import { Presentation } from "./Presentation";

type Props = {
  selectedWorkContentAlbums: WorkContentAlbum[];
  albumCategoryOptions: OptionProps[];
  handleChangeAlbumSortNo: (currentSortNo: number, swapSortNo: number) => void;
  handleChangeAlbumCategory: (albumCategoryId: number, clientImageId: number) => void;
};

export const AlbumCassettes: FC<Props> = ({
  selectedWorkContentAlbums,
  albumCategoryOptions,
  handleChangeAlbumSortNo,
  handleChangeAlbumCategory,
}) => {
  return (
    <Presentation
      selectedWorkContentAlbums={selectedWorkContentAlbums}
      albumCategoryOptions={albumCategoryOptions}
      handleChangeAlbumSortNo={handleChangeAlbumSortNo}
      handleChangeAlbumCategory={handleChangeAlbumCategory}
    />
  );
};
